export { default as MedPieChart } from './MedPieChart';
